import { createDashboardRoute } from "@components-common/routes";
const basePath = "/lecturers";

export const lecturersAreaRoutes = {
  dashboard: createDashboardRoute<"lecturers">("lecturers",{basePath,roles:['LECTURER']})
}

export type LecturersAreaRouteIds = typeof lecturersAreaRoutes[keyof typeof lecturersAreaRoutes]["id"];
